const PrimaryBtn = ({ children, submitBtn, type }) => {
  return (
    <button
      className="btn btn-danger py-2 fw-medium"
      type={type}
      onClick={submitBtn}
    >
      {children}
    </button>
  );
};

export default PrimaryBtn;
